import React, { Component } from 'react';
import { Icon, Checkbox } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import ClassNames from 'classnames';

import ReactTableWrapper from 'Common/ReactTableWrapper';
import { defaultDateFormat } from 'Common/GeneralHelper';

const MatchingCellContent = ({ original, accessor, children }) => {
  const isMatch =
    original.MemberMatches.findIndex(i => i.TargetMember === accessor) > -1;

  return (
    <span className={ClassNames({ 'is-success': isMatch })}>
      {children} {isMatch && <Icon name="checkmark" />}
    </span>
  );
};

export class PossibleMatchTable extends Component {
  static propTypes = {
    possibleMatches: PropTypes.array.isRequired,
    onRowSelect: PropTypes.func.isRequired,
    selectedMatchId: PropTypes.string,
    loading: PropTypes.bool,
  };

  static defaultProps = {
    loading: false,
    selectedMatchId: null,
  };

  columns = [
    {
      Header: 'Selected',
      accessor: '',
      maxWidth: 60,
      sortable: false,
      filterable: false,
      Cell: ({ original }) => {
        if (original) {
          return (
            <div style={{ textAlign: 'center' }}>
              <Checkbox
                radio
                checked={
                  this.props.selectedMatchId === original.Target.Id
                    ? true
                    : false
                }
                // onChange={() => {
                //   this.handleCheckedItem(!original.Selected, original);
                // }}
              />
            </div>
          );
        }
      },
    },
    {
      Header: 'Declined Benefits',
      accessor: 'Target.Household.DeclineBenefits',
      Cell: ({ value, original }) => (
        <span className={ClassNames({ 'is-error': value === 'Y' })}>
          {value === 'Y' ? 'Yes' : 'No'}
        </span>
      ),
      sortable: true,
      minWidth: 115,
    },
    {
      Header: 'Student Number',
      accessor: 'Target.Id',
      Cell: ({ value, original }) => (
        <MatchingCellContent original={original} accessor="Id">
          {value}
        </MatchingCellContent>
      ),
      sortable: true,
      minWidth: 150,
    },
    {
      Header: 'State Number',
      accessor: 'Target.StateNum',
      Cell: ({ value, original }) => (
        <MatchingCellContent original={original} accessor="StateNum">
          {value}
        </MatchingCellContent>
      ),
      sortable: true,
      minWidth: 110,
    },
    {
      Header: 'Last Name',
      accessor: 'Target.LastName',
      Cell: ({ value, original }) => (
        <MatchingCellContent original={original} accessor="LastName">
          {value}
        </MatchingCellContent>
      ),
      minWidth: 150,
    },
    {
      Header: 'First Name',
      accessor: 'Target.FirstName',
      Cell: ({ value, original }) => (
        <MatchingCellContent original={original} accessor="FirstName">
          {value}
        </MatchingCellContent>
      ),
      minWidth: 150,
    },

    {
      Header: 'Birth Date',
      accessor: 'Target.BirthDate',
      Cell: ({ value, original }) => (
        <MatchingCellContent original={original} accessor="BirthDate">
          {defaultDateFormat(value)}
        </MatchingCellContent>
      ),
    },
    {
      Header: 'Case Number',
      accessor: 'Target.CaseNumber',
      Cell: ({ value, original }) => (
        <MatchingCellContent original={original} accessor="CaseNumber">
          {value}
        </MatchingCellContent>
      ),
    },
    {
      Header: 'Case Type',
      accessor: 'Target.CaseType.Description',
      Cell: ({ value, original }) => (
        <MatchingCellContent original={original} accessor="CaseTypeId">
          {value}
        </MatchingCellContent>
      ),
    },
    {
      Header: 'HoH Last Name',
      accessor: 'Target.HHLastName',
      Cell: ({ value, original }) => (
        <MatchingCellContent original={original} accessor="HHLastName">
          {value}
        </MatchingCellContent>
      ),
      sortable: true,
      width: 150,
    },
    {
      Header: 'HoH First Name',
      accessor: 'Target.HHFirstName',
      Cell: ({ value, original }) => (
        <MatchingCellContent original={original} accessor="HHFirstName">
          {value}
        </MatchingCellContent>
      ),
      sortable: true,
      minWidth: 150,
    },

    {
      Header: 'Address 1',
      accessor: 'Target.Address1',
      Cell: ({ value, original }) => (
        <MatchingCellContent original={original} accessor="Address1">
          {value}
        </MatchingCellContent>
      ),
      sortable: true,
    },
    {
      Header: 'Address 2',
      accessor: 'Target.Address2',
      Cell: ({ value, original }) => (
        <MatchingCellContent original={original} accessor="Address2">
          {value}
        </MatchingCellContent>
      ),
      sortable: true,
    },
    {
      Header: 'City',
      accessor: 'Target.City',
      Cell: ({ value, original }) => (
        <MatchingCellContent original={original} accessor="City">
          {value}
        </MatchingCellContent>
      ),
      sortable: true,
    },
    {
      Header: 'State',
      accessor: 'Target.State',
      Cell: ({ value, original }) => (
        <MatchingCellContent original={original} accessor="State">
          {value}
        </MatchingCellContent>
      ),
      sortable: true,
    },
    {
      Header: 'Zip Code',
      accessor: 'Target.ZipCode',
      Cell: ({ value, original }) => (
        <MatchingCellContent original={original} accessor="ZipCode">
          {value}
        </MatchingCellContent>
      ),
      sortable: true,
    },
    {
      Header: 'Application Date',
      accessor: 'Target.Household.ApplicationDate',
      Cell: ({ value, original }) => defaultDateFormat(value),
      sortable: true,
      minWidth: 140,
    },
  ];

  render() {
    const {
      loading,
      onRowSelect,
      possibleMatches,
      selectedMatchId,
    } = this.props;

    return (
      <ReactTableWrapper
        loading={loading}
        data={possibleMatches}
        columns={this.columns}
        minRows={10}
        pageSize={10}
        pageSizeOptions={[10]}
        filterable={true}
        resizable={true}
        noDataText="No Possible Matches Found"
        showMenu={true}
        getTrGroupProps={(state, rowInfo, column) => {
          return rowInfo && rowInfo.row
            ? {
                className: ClassNames('cursor-pointer', {
                  selected: rowInfo.original.Target.Id === selectedMatchId,
                }),
                onClick: e => onRowSelect(rowInfo.original),
              }
            : {};
        }}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/dcunmatchedutility/components/PossibleMatchTable.js